import React, { useContext } from "react";

import GraphSelect from "../graph-select/graph-select.component";
import { MatchContext } from "../../context";
import GraphHighchart from "../graph-highchart/graph-highchart.component";

export default function Graph({
  handleSensorChange,
  value,
  dataId,
}): JSX.Element {
  const { state } = useContext(MatchContext);

  return (
    <React.Fragment>
      <GraphSelect
        handleSensorChange={handleSensorChange}
        value={value}
        dataId={dataId}
      />
      {value && state.highlightedCols.length ? (
        <GraphHighchart
          tag={value}
          stockpiles={state.highlightedCols}
          dataId={dataId}
        />
      ) : (
        <div className="no-data-block">
          <span className="no-data-text">
            Select a stockpile to review data
          </span>
        </div>
      )}
    </React.Fragment>
  );
}
